import {useMutation } from "@tanstack/react-query"
import { contactUs } from "../repositories/contact-message/contactRepository";

export const useContactUsMutation = () =>{
  return useMutation({
    mutationFn:contactUs,
  });
};